export default __webpack_public_path__ + "static/media/apples.b7c17012.jpg";